import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
  GridSelectionChangeEvent,
  GridHeaderSelectionChangeEvent,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { getter, Typography } from "@progress/kendo-react-common";
import { Button } from "@progress/kendo-react-buttons";
import {
  getSelectedState,
  HeaderThElement,
} from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import {
  ActiveInactiveContact,
  bulkUploadContacts,
  deleteContact,
  downloadContactExcel,
  exportGoogleContacts,
  getAllContacts,
  importGoogleContacts,
} from "./services/contact.services";
import {
  clearContactFilterDetails,
  clearContactID,
  setContactFilterDetails,
  setContactID,
} from "./contactSlice";
import { checkAcessRights } from "../../_helper/helper";
import {
  CONTACTSORTTYPE,
  CONTACTTYPE,
  DELETE_ACCESS,
  EDIT_ACCESS,
  EXCEL_EXPORT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { getAllActiveUsers } from "../user/services/user.services";
import { SuccessToast } from "../../components/toast/Toasts";
import ContactFilter from "./ContactFilter";
import { Switch } from "@progress/kendo-react-inputs";
import { FiEdit } from "react-icons/fi";
import {
  clearCurrentPage,
  setCurrentPage,
  setPageLimit,
} from "../pagination/paginationSlice";
import ButtonCreate from "../../components/drawer/ButtonCreate";
import { RxCross1 } from "react-icons/rx";
import FormFileUpload from "../../components/formFields/FormFileUpload";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import contactSample from "../../assets/Excels/contact_sample.xlsx";
import { MdKeyboardBackspace } from "react-icons/md";
import FormDatePicker from "../../components/formFields/FormDateField";
import moment from "moment";
import { saveAs } from "file-saver";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import IconComponent from "../../components/common/IconComponent";
import { FcGoogle } from "react-icons/fc";
import { CgCopy } from "react-icons/cg";
type IBooking = any;
import { FaEye } from "react-icons/fa";

const Contact: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const ContactFilterDetails = useAppSelector(
    (state) => state.contact.ContactFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  const [isTokenAvailable, setIsTokenAvailable] = useState<string>("contacts");
  const [selectedContact, setSelectedContact] = useState<any>(null);

  const handleOpenBookingListDialog = (contact: any) => {
    setSelectedContact(contact);
    dispatch(openDialog("contactBookingList"));
  };

  const handleImportContacts = async () => {
    const res = await dispatch(importGoogleContacts());
    if (res.meta.requestStatus === "fulfilled") {
      const payload = {
        filterName: ContactFilterDetails?.filterName,
        filterMobileNo: ContactFilterDetails?.filterMobileNo,
        filterEmailID: ContactFilterDetails?.filterEmailID,
        filterContactType: ContactFilterDetails?.filterContactType,
        filterFromDate: ContactFilterDetails?.filterFromDate,
        filterToDate: ContactFilterDetails?.filterToDate,
        filterUnassignedContacts:
          ContactFilterDetails?.filterUnassignedContacts,
        SortType: ContactFilterDetails?.SortType,
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      dispatch(getAllContacts(payload));
    } else {
      setIsTokenAvailable("google");
    }
  };
  const handleExportContacts = async () => {
    const res = await dispatch(exportGoogleContacts());
    if (res.meta.requestStatus === "fulfilled") {
      return;
    } else {
      setIsTokenAvailable("google");
    }
  };

  return (
    <>
      <DeleteContactDialog />
      <BulkUploadContactDialog />
      <ExcelDownloadDialog />
      <ContactBookingListDialog selectedContact={selectedContact} />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0px 20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <IconButton
              fillMode="solid"
              title="Back"
              onClick={() => navigate(-1)}
              icon={MdKeyboardBackspace}
              iconClassName="absolute-position"
              style={{ height: 30 }}
              iconStyle={{ fontSize: "20px" }}
            />
            <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
              Contact List
            </Typography.h4>
          </div>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            {false && (
              <>
                {isTokenAvailable === "contacts" ? (
                  <>
                    <Button
                      themeColor={"light"}
                      fillMode={"solid"}
                      onClick={() => handleImportContacts()}
                    >
                      Import Contacts
                    </Button>
                    <Button
                      themeColor={"light"}
                      fillMode={"solid"}
                      onClick={() => handleExportContacts()}
                    >
                      Export Contacts
                    </Button>
                  </>
                ) : isTokenAvailable === "google" ? (
                  <Button
                    type="button"
                    themeColor={"light"}
                    style={{ color: "#000" }}
                    fillMode={"solid"}
                    // onClick={() => login()}
                    className="d-flex align-items-center gap-2"
                  >
                    <IconComponent icon={FcGoogle} className="fs-5" /> Login
                    with Google
                  </Button>
                ) : null}
              </>
            )}

            {isAddAccess && (
              <ButtonCreate label="Add New" drawerName="contactForm" />
            )}
          </div>
        </GridLayoutItem>
        <GridLayoutItem>
          <ContactGridComponent
            onOpenBookingListDialog={handleOpenBookingListDialog}
          />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const ContactGridComponent: React.FC<{
  onOpenBookingListDialog: (contact: any) => void;
}> = ({ onOpenBookingListDialog }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  //   const isAddAccess = checkAcessRights("/inquiry", INSERT_ACCESS);
  const isEditBtnRef = useRef<any>(false);
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);

  const ContactList = useAppSelector((state) => state.contact.ContactList);
  const activeTabIndex = useAppSelector(
    (state) => state.contact.activeTabIndex,
  );
  const loading = useAppSelector((state) => state.contact.loading);
  const ContactFilterDetails = useAppSelector(
    (state) => state.contact.ContactFilterDetails,
  );
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS,
  );
  const UserTypeIDString = useAppSelector(
    (state) => state.login.loginDetails.UserTypeID,
  );
  const UserTypeID = parseInt(UserTypeIDString);

  const [selectedState, setSelectedState] = React.useState<{
    [id: string]: boolean | number[];
  }>({});

  useEffect(() => {
    const payload = {
      filterName: ContactFilterDetails?.filterName,
      filterMobileNo: ContactFilterDetails?.filterMobileNo,
      filterEmailID: ContactFilterDetails?.filterEmailID,
      filterContactType: ContactFilterDetails?.filterContactType,
      filterFromDate: ContactFilterDetails?.filterFromDate,
      filterToDate: ContactFilterDetails?.filterToDate,
      filterUnassignedContacts: ContactFilterDetails?.filterUnassignedContacts,
      SortType: ContactFilterDetails?.SortType,
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(getAllContacts(payload));
  }, [ContactFilterDetails, activeTabIndex, pageLimit, currentPage]);

  useEffect(() => {
    setSelectedState({});
  }, [ContactList]);

  useEffect(() => {
    dispatch(getAllActiveUsers());
    return () => {
      dispatch(closeDialog());
      if (!isEditBtnRef.current) {
        dispatch(clearContactFilterDetails());
      }
    };
  }, []);

  const dataState = ContactList?.map((dataItem: any) =>
    Object.assign({ selected: false }, dataItem),
  );

  const DATA_ITEM_KEY: string = "ID";
  const SELECTED_FIELD: string = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const onSelectionChange = React.useCallback(
    (event: GridSelectionChangeEvent) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState: selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });
      setSelectedState(newSelectedState);
    },
    [selectedState],
  );

  const onHeaderSelectionChange = React.useCallback(
    (event: GridHeaderSelectionChangeEvent) => {
      const checkboxElement: any = event.syntheticEvent.target;
      const checked = checkboxElement.checked;
      const newSelectedState: { [key: string]: boolean } = {};

      event?.dataItems?.forEach((item: any) => {
        newSelectedState[idGetter(item)] = checked;
      });
      setSelectedState(newSelectedState);
    },
    [],
  );

  const MyEditCommandCell = (props: any) => {
    const handleEditContact = (ID: number) => {
      navigate("/contact/edit", { state: { ContactID: ID } });
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteContact"));
      dispatch(setContactID(ID));
    };

    return (
      <td
        {...props?.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props?.tdProps?.style }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => {
              isEditBtnRef.current = true;
              handleEditContact(props.dataItem.ID);
            }}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
      </td>
    );
  };

  const MyActiveInActtiveCommandCell = (props: any) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem.IsActive);

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.ID,
        IsActive: !IsActive,
      };
      dispatch(ActiveInactiveContact(data)).then((response: any) => {
        if (response.payload?.data?.Status === 200) {
          dispatch(
            getAllContacts({
              ...ContactFilterDetails,
              limit: +pageLimit,
              skip: +currentPage * +pageLimit,
            }),
          );
        } else {
          dispatch(
            getAllContacts({
              ...ContactFilterDetails,
              limit: +pageLimit,
              skip: +currentPage * +pageLimit,
            }),
          );
        }
      });
    };

    return (
      <td
        {...props?.tdProps}
        className={`action-td ${props.className}`}
        style={{ ...props?.tdProps?.style, textAlign: "center" }}
      >
        <Switch
          disabled={isEditAccess ? false : true}
          name="IsActive"
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 8 || props.index === 9 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const handleSortChange = (value: number) => {
    dispatch(clearCurrentPage());
    dispatch(
      setContactFilterDetails({
        ...ContactFilterDetails,
        SortType: value || "CreatedOnDesc",
      }),
    );
  };

  const gridRef = useRef<any>(null);

  const handleOpenExcelDownloadDialog = () => {
    dispatch(openDialog("filterforexceldownload"));
  };

  const handleOpenBulkUploadDialog = () => {
    dispatch(openDialog("bulkUploadContact"));
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <div
        style={{
          position: "relative",
          marginBottom: "10px",
          padding: "10px",
          border: "1px solid lightgray",
          borderRadius: "5px",
          boxShadow: "0 0 10px gainsboro",
        }}
      >
        <ContactFilter />
      </div>
      <Form
        // onSubmit={handleSubmit}
        initialValues={{ User: "", SortType: "CreatedOnDesc" }}
        render={() => (
          <FormElement>
            <div
              style={{
                marginTop: 10,
                padding: "10px",
                border: "1px solid lightgray",
                borderRadius: "5px",
                boxShadow: "0 0 10px gainsboro",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 10,
                  justifyContent: "space-between",
                }}
                className="mt-1 mb-3"
              >
                <div className="d-flex gap-2 ">
                  {isExcelAccess && (
                    <Button
                      themeColor={"primary"}
                      fillMode={"solid"}
                      onClick={() => handleOpenExcelDownloadDialog()}
                    >
                      Excel Download
                    </Button>
                  )}
                  {isAddAccess && (
                    <Button
                      themeColor={"primary"}
                      fillMode={"solid"}
                      onClick={() => handleOpenBulkUploadDialog()}
                    >
                      Bulk Upload
                    </Button>
                  )}
                </div>
                <Field
                  wrapperClassName="m-0"
                  wrapperStyle={{ minWidth: 300 }}
                  name="SortType"
                  placeholder="Sort Contacts"
                  component={FormSelectionField}
                  onChange={(e) => handleSortChange(e?.value)}
                  options={CONTACTSORTTYPE?.map((sortType: any) => ({
                    value: sortType.value,
                    label: sortType.label,
                  }))}
                />
              </div>
              <KendoGrid
                style={{ maxHeight: "calc(100vh - 300px)" }}
                className="responsive-table"
                filterable={false}
                dataItemKey={DATA_ITEM_KEY}
                data={ContactList?.map((item: any) => ({
                  ...item,
                  [SELECTED_FIELD]: selectedState[idGetter(item)],
                }))}
                total={ContactList[0]?.ItemCount || ContactList?.length}
                skip={currentPage * pageLimit}
                take={pageLimit}
                selectedField={SELECTED_FIELD}
                pageable={{
                  buttonCount: 5,
                  pageSizes: [5, 10, 50, 100, 500],
                  pageSizeValue: pageLimit,
                  type: "input",
                }}
                onSelectionChange={onSelectionChange}
                onHeaderSelectionChange={onHeaderSelectionChange}
                onPageChange={pageChange}
                cells={{
                  headerCell: HeaderCustomCell,
                  data: MyDataCustomCell,
                }}
                reorderable={true}
              >
                {UserTypeID < 3 && (
                  <Column
                    filterable={false}
                    field={SELECTED_FIELD}
                    width={50}
                    headerSelectionValue={
                      dataState?.findIndex(
                        (item: any) => !selectedState[idGetter(item)],
                      ) === -1
                    }
                  />
                )}
                <Column
                  field="Name"
                  title="Name"
                  width={300}
                  cells={{
                    data: (props: any) => (
                      <td>
                        {isEditAccess ? (
                          <div
                            className="hoverableName"
                            onClick={() => {
                              isEditBtnRef.current = true;
                              navigate("/contact/edit", {
                                state: {
                                  ContactID: props.dataItem?.ID,
                                },
                              });
                            }}
                          >
                            {props.dataItem?.FirstName}{" "}
                            {props.dataItem?.LastName}
                          </div>
                        ) : (
                          <div className="normalName">
                            <p className="m-0">
                              {props.dataItem?.FirstName}{" "}
                              {props.dataItem?.LastName}
                            </p>
                          </div>
                        )}
                      </td>
                    ),
                  }}
                />
                <Column field="MobileNo" title="Mobile No." width={200} />
                <Column field="EmailID" title="Email ID" width={200} />
                <Column
                  field="ReferalCode"
                  title="Referal Code"
                  width={150}
                  cells={{
                    data: (props: any) => (
                      <td>
                        <div
                          className={
                            props.dataItem?.ReferalCode ? "hoverableName" : ""
                          }
                          onClick={() => {
                            if (
                              props.dataItem?.ReferalCode &&
                              props.dataItem?.ReferalCode !== ""
                            ) {
                              navigator.clipboard.writeText(
                                props.dataItem?.ReferalCode || "",
                              );
                              SuccessToast("Referal Code Copied Successfully");
                            }
                          }}
                        >
                          {props.dataItem?.ReferalCode !== "" ? (
                            <IconComponent icon={CgCopy} />
                          ) : (
                            ""
                          )}{" "}
                          {props.dataItem?.ReferalCode || "---"}
                        </div>
                      </td>
                    ),
                  }}
                />
                <Column
                  field="BookingCount"
                  title="Bookings"
                  width={130}
                  cells={{
                    data: (props: any) => {
                      const count = props.dataItem?.BookingCount || 0;
                      return (
                        <td className="text-center">
                          <div
                            className={count ? "hoverableName" : ""}
                            style={{
                              cursor: count ? "pointer" : "default",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "5px",
                            }}
                            onClick={() => {
                              if (count) {
                                onOpenBookingListDialog(props.dataItem);
                              }
                            }}
                          >
                            <div>{count}</div>
                            <div>
                              {count > 0 && <IconComponent icon={FaEye} />}
                            </div>
                          </div>
                        </td>
                      );
                    },
                  }}
                />
                <Column
                  field="ContactType"
                  title="Contact Type"
                  width={150}
                  cells={{
                    data: (props: any) => (
                      <td className="text-center fw-bold">
                        {props.dataItem?.ContactType}
                      </td>
                    ),
                  }}
                />
                <Column field="CreatedOn" title="Created On" width={130} />
                <Column
                  field="ID"
                  title="Status"
                  cells={{ data: MyActiveInActtiveCommandCell }}
                  width={"90px"}
                  filterable={false}
                  locked={true}
                />
                {(isEditAccess || isDeleteAccess) && (
                  <Column
                    field="ID"
                    title="Actions"
                    cells={{ data: MyEditCommandCell }}
                    width={"110px"}
                    filterable={false}
                    locked={true}
                  />
                )}
              </KendoGrid>
            </div>
          </FormElement>
        )}
      />
    </>
  );
};

const BulkUploadContactDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const ContactFilterDetails = useAppSelector(
    (state) => state.contact.ContactFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const loading = useAppSelector((state) => state.contact.bulkUploadLoading);

  const handleSubmit = async (values: any) => {
    const formData = new FormData();
    formData.append("file", values?.ContactDocument[0]?.getRawFile());

    dispatch(bulkUploadContacts(formData)).then((res: any) => {
      if (res?.payload?.Status === 200) {
        dispatch(closeDialog());
        dispatch(
          getAllContacts({
            ...ContactFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          }),
        );
      }
    });
  };

  return (
    <>
      {dialogName === "bulkUploadContact" && (
        <AppDialog>
          <>
            {loading && <LoadingPanel gridRef={gridRef} />}
            <Form
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ minWidth: 500 }}>
                  <GridLayout>
                    <GridLayoutItem className="position-relative">
                      <Typography.h4 className="typography-head">
                        {"Bulk Upload Contacts"}
                      </Typography.h4>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ marginRight: 4, top: 7 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="ContactDocument"
                        type="file"
                        filetype="file"
                        label="Contacts File"
                        accept=".xls, .xlsx, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        multiple={false}
                        component={FormFileUpload}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: 20,
                      }}
                    >
                      <Button
                        themeColor={"primary"}
                        fillMode={"solid"}
                        style={{ marginRight: 10 }}
                        onClick={() => window.open(contactSample)}
                      >
                        Show Sample
                      </Button>
                      <div>
                        <DialogCloseButton themeColor="primary" />
                        <ButtonWithLoading
                          label={"Upload"}
                          type="submit"
                          disabled={!formRenderProps.allowSubmit || loading}
                          loading={loading}
                        />
                      </div>
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

const ExcelDownloadDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const loading = useAppSelector((state) => state.contact.ContactLoading);
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS,
  );

  const handleSubmit = async (values: any) => {
    const payload = {
      FromDate: values?.FromDate ? values.FromDate : "",
      ToDate: values?.ToDate ? values.ToDate : "",
      ContactType: values?.ContactType ? values.ContactType : "",
      ContactOwner: values?.ContactOwner ? values.ContactOwner : "",
      AssignedUser: values?.AssignedUser ? values.AssignedUser : "",
    };
    const response = await dispatch(downloadContactExcel(payload));

    if (response.meta.requestStatus === "fulfilled" && response.payload) {
      const byteArray = response.payload;

      const blob = new Blob([byteArray], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "contactlist.xlsx");
      SuccessToast("Excel download succeessfully!");
      dispatch(closeDialog());
    }
  };

  return (
    <>
      {dialogName === "filterforexceldownload" && (
        <AppDialog>
          <>
            {loading && <LoadingPanel gridRef={gridRef} />}
            <Form
              onSubmit={handleSubmit}
              render={(formRenderProps: FormRenderProps) => (
                <FormElement style={{ minWidth: 600 }}>
                  <GridLayout
                    cols={[{ width: "49.5%" }, { width: "49.5%" }]}
                    gap={{ rows: 10, cols: 10 }}
                  >
                    <GridLayoutItem colSpan={2} className="position-relative">
                      <Typography.h4 className="typography-head">
                        {"Filter crieteria for excel downoad"}
                      </Typography.h4>
                      <IconButton
                        className="typography-dialog-close-icon"
                        type="button"
                        fillMode={"flat"}
                        themeColor={"dark"}
                        style={{ marginRight: 4, top: 7 }}
                        onClick={() => dispatch(closeDialog())}
                        icon={RxCross1}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"FromDate"}
                        label="From Date"
                        format="dd/MM/yyyy"
                        component={FormDatePicker}
                        validator={requiredValidator}
                        astrike={true}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name={"ToDate"}
                        label="To Date"
                        format="dd/MM/yyyy"
                        validator={requiredValidator}
                        astrike={true}
                        disabled={!formRenderProps.valueGetter("FromDate")}
                        component={FormDatePicker}
                        minDate={moment(
                          formRenderProps.valueGetter("FromDate"),
                        ).toDate()}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem colSpan={2}>
                      <Field
                        name={"ContactType"}
                        label={"Contact Type"}
                        placeholder="i.e. B2B"
                        component={FormSelectionField}
                        options={CONTACTTYPE?.map((initial: any) => {
                          return {
                            value: initial?.value,
                            label: initial?.label,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      colSpan={2}
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        gap: 10,
                        marginTop: 20,
                      }}
                    >
                      <Button
                        themeColor={"primary"}
                        fillMode={"outline"}
                        type="button"
                        disabled={loading}
                        onClick={() => dispatch(closeDialog())}
                      >
                        Cancel
                      </Button>
                      {isExcelAccess && (
                        <Button
                          themeColor={"primary"}
                          fillMode={"solid"}
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <div
                              role="status"
                              className="flex items-center gap-2"
                            >
                              <svg
                                aria-hidden="true"
                                style={{
                                  width: "18px",
                                  height: "18px",
                                  color: "white",
                                  fill: "var(--brand)",
                                  animation: "spin 1s linear infinite",
                                }}
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                  fill="#1a5490"
                                />
                              </svg>
                              <span className="sr-only">Loading...</span>
                            </div>
                          ) : (
                            "Download"
                          )}
                        </Button>
                      )}
                    </GridLayoutItem>
                  </GridLayout>
                </FormElement>
              )}
            />
          </>
        </AppDialog>
      )}
    </>
  );
};

const DeleteContactDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const ContactID = useAppSelector((state) => state.contact.ContactID);
  const ContactFilterDetails = useAppSelector(
    (state) => state.contact.ContactFilterDetails,
  );
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteContact(ID));
      if (response.meta.requestStatus === "fulfilled") {
        dispatch(closeDialog());
        dispatch(clearContactID());
        dispatch(
          getAllContacts({
            ...ContactFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          }),
        );
      } else {
        dispatch(closeDialog());
        dispatch(clearContactID());
        dispatch(
          getAllContacts({
            ...ContactFilterDetails,
            limit: +pageLimit,
            skip: +currentPage * +pageLimit,
          }),
        );
      }
    }
  };
  return (
    <>
      {dialogName === "deleteContact" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Contact?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Contact?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(ContactID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const ContactBookingListDialog: React.FC<{ selectedContact: any }> = ({
  selectedContact,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const [bookingList, setBookingList] = useState<IBooking[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (dialogName === "contactBookingList" && selectedContact?.MobileNo) {
      setBookingList([]);
      setLoading(false);
    }
  }, [dialogName, selectedContact]);

  const handleEditBooking = (bookingId: any) => {
    dispatch(closeDialog());
    navigate("/booking/edit", {
      state: { BookingID: bookingId },
    });
  };

  const contactName =
    selectedContact?.FirstName || selectedContact?.LastName
      ? `${selectedContact?.FirstName || ""} ${selectedContact?.LastName || ""}`.trim()
      : selectedContact?.Name || "---";

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className="table-cell">
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      {dialogName === "contactBookingList" && (
        <AppDialog>
          <div style={{ minWidth: 900, maxWidth: 1150 }}>
            <GridLayoutItem className="position-relative">
              <Typography.h4 className="typography-head">
                {"Booking List"}
              </Typography.h4>
              <IconButton
                className="typography-dialog-close-icon"
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4, top: 7 }}
                onClick={() => dispatch(closeDialog())}
                icon={RxCross1}
              />
            </GridLayoutItem>
            {selectedContact && (
              <div
                style={{
                  background: "#f8f9fa",
                  border: "1px solid #e9ecef",
                  borderRadius: "6px",
                  padding: "10px 15px",
                  marginTop: "10px",
                  marginBottom: "15px",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "15px 30px",
                  fontSize: "14px",
                }}
              >
                <div>
                  <span className="text-muted">Name: </span>
                  <span className="fw-bold">{contactName}</span>
                </div>
                <div>
                  <span className="text-muted">Mobile No.: </span>
                  <span className="fw-bold">
                    {selectedContact?.MobileNo || "---"}
                  </span>
                </div>
                {selectedContact?.EmailID && (
                  <div>
                    <span className="text-muted">Email ID: </span>
                    <span className="fw-bold">{selectedContact?.EmailID}</span>
                  </div>
                )}
                {selectedContact?.ContactType && (
                  <div>
                    <span className="text-muted">Contact Type: </span>
                    <span className="fw-bold">
                      {selectedContact?.ContactType}
                    </span>
                  </div>
                )}
              </div>
            )}
            {loading && <LoadingPanel gridRef={gridRef} />}
            <div style={{ marginTop: 10, maxHeight: 450, overflowY: "auto" }}>
              {bookingList && bookingList.length > 0 ? (
                <KendoGrid
                  data={bookingList}
                  style={{ maxHeight: 400 }}
                  className="responsive-table"
                  cells={{
                    headerCell: HeaderCustomCell,
                    data: MyDataCustomCell,
                  }}
                >
                  <Column
                    field="BookingDate"
                    title="Booking Date"
                    width={140}
                    cell={(props: any) => (
                      <td>
                        <div
                          className="hoverableName fw-bold"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleEditBooking(props.dataItem?.ID)}
                        >
                          {props.dataItem?.BookingDate
                            ? moment(props.dataItem.BookingDate).format(
                                "DD/MM/YYYY",
                              )
                            : "-"}
                        </div>
                      </td>
                    )}
                  />
                  <Column
                    field="CheckinDate"
                    title="Check-in Date & Time"
                    width={180}
                    cell={(props: any) => (
                      <td>
                        <div>
                          {props.dataItem?.CheckinDate
                            ? moment(
                                props.dataItem.CheckinDate,
                                "YYYY-MM-DD",
                              ).format("DD/MM/YYYY")
                            : "-"}{" "}
                          {props.dataItem?.CheckinTime && (
                            <span>
                              {moment(
                                props.dataItem.CheckinTime,
                                "HH:mm:ss",
                              ).format("hh:mm A")}
                            </span>
                          )}
                        </div>
                      </td>
                    )}
                  />
                  <Column
                    field="RoomType"
                    title="Room Type"
                    width={140}
                    cell={(props: any) => (
                      <td>{props.dataItem?.RoomType || "-"}</td>
                    )}
                  />
                  <Column
                    field="NoOfRooms"
                    title="Rooms / Pax"
                    width={130}
                    cell={(props: any) => (
                      <td>
                        Rooms: <strong>{props.dataItem?.NoOfRooms || 0}</strong>
                        <br />
                        Pax: <strong>{props.dataItem?.NoOfPax || 0}</strong>
                      </td>
                    )}
                  />
                  <Column
                    field="Source"
                    title="Source"
                    width={120}
                    cell={(props: any) => (
                      <td>{props.dataItem?.Source || "-"}</td>
                    )}
                  />
                  <Column
                    field="Remarks"
                    title="Remarks"
                    width={200}
                    cell={(props: any) => (
                      <td>{props.dataItem?.Remarks || "-"}</td>
                    )}
                  />
                  <Column
                    field="ID"
                    title="Actions"
                    width={90}
                    cell={(props: any) => (
                      <td className="action-td text-center">
                        <IconButton
                          type="button"
                          fillMode="flat"
                          size="small"
                          title="Edit Booking"
                          onClick={() => handleEditBooking(props.dataItem?.ID)}
                          icon={FiEdit}
                          iconClassName="absolute-position"
                          iconStyle={{ fontSize: "18px" }}
                        />
                      </td>
                    )}
                  />
                </KendoGrid>
              ) : (
                !loading && (
                  <div className="text-center p-4">
                    <Typography.p>
                      No Bookings found for this contact.
                    </Typography.p>
                  </div>
                )
              )}
            </div>
            <div className="text-end mt-3">
              <DialogCloseButton text="Close" themeColor="primary" />
            </div>
          </div>
        </AppDialog>
      )}
    </>
  );
};

export default Contact;
